const effects = {
  transition: '.1s ease',
  slide: '.5s cubic-bezier(.42,0,.58,1)',
};

export default effects;
